import { SavedItemDropdownAction } from 'Angular/features/components/saved-items/enums/saved-item-dropdown-action.enum';
export const SAVED_ITEM_DROPDOWN_OPTIONS_BASE = [
    {
        type: 'option',
        label: 'Open',
        value: SavedItemDropdownAction.OPEN,
        icon: 'icon-open',
    },
    {
        type: 'option',
        label: 'Save',
        value: SavedItemDropdownAction.SAVE,
    },
    {
        type: 'option',
        label: 'Save as...',
        value: SavedItemDropdownAction.SAVE_AS,
    },
    {
        type: 'option',
        label: 'Set as Default',
        value: SavedItemDropdownAction.SET_AS_DEFAULT,
    },
    {
        type: 'option',
        label: 'Rename',
        value: SavedItemDropdownAction.RENAME,
    },
    {
        type: 'divider',
        label: null,
        value: null,
    },
    {
        type: 'option',
        label: 'Close',
        value: SavedItemDropdownAction.CLOSE,
    },
    {
        type: 'option',
        label: 'Delete',
        value: SavedItemDropdownAction.DELETE,
        icon: 'icon-delete',
    },
];
if (window.USER?.isStaff) {
    // For staff users, add 'Copy State to Clipboard' option
    SAVED_ITEM_DROPDOWN_OPTIONS_BASE.push({
        type: 'divider',
        label: null,
        value: null,
    }, {
        type: 'option',
        label: 'Copy State to Clipboard',
        value: SavedItemDropdownAction.COPY_STATE,
    });
}
// New from template option with divider
export const SAVED_ITEM_DROPDOWN_NEW_FROM_TEMPLATE_OPTIONS = [
    {
        type: 'option',
        label: 'New from Template',
        value: SavedItemDropdownAction.NEW_FROM_TEMPLATE,
        icon: 'icon-template',
    },
    {
        type: 'divider',
        label: null,
        value: null,
    },
];
export const SAVED_ITEM_DROPDOWN_OPTIONS = SAVED_ITEM_DROPDOWN_NEW_FROM_TEMPLATE_OPTIONS.concat(SAVED_ITEM_DROPDOWN_OPTIONS_BASE);
export const SAVED_ITEM_DROPDOWN_OPTIONS_NO_TEMPLATE = SAVED_ITEM_DROPDOWN_OPTIONS_BASE;
